// @ts-nocheck
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import ProductAvailability, { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import React from "react";
import { connect } from "react-redux";

/* Store Custom Code - Start */
import ProductAvailabilityWithPickup from "@store/Library/Components/ProductAvailabilityWithPickup";
/* Store Custom Code - End */

interface OwnProps {
    isProductDetailsPage?: boolean;
    configurationCompleted?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    return {
        includeRealTimeInventoryAndPricingForSeo:
            getSettingsCollection(state).websiteSettings.includeRealTimeInventoryAndPricingForSeo,
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProduct;

const ProductContextAvailability = ({
    includeRealTimeInventoryAndPricingForSeo,
    productInfo,
    product,
    isProductDetailsPage,
    configurationCompleted,
    extendedStyles,
}: Props) => {
    const { inventory, unitOfMeasure, failedToLoadInventory } = productInfo;

    const availability =
        inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;

    if (
        (getIsWebCrawler() && !includeRealTimeInventoryAndPricingForSeo) ||
        product.isVariantParent ||
        (product.properties?.hideAvailability && product.properties?.hideAvailability?.toLowerCase() === "true") // Store Custom Code
    ) {
        return null;
    }
    return (
        // Store Custom Code
        <ProductAvailabilityWithPickup
            isProductDetailsPage={isProductDetailsPage}
            isScratchAndDent={product.properties?.isScratchAndDent}
            dcneAvailability={product.properties?.availabilityStatus}
            canAddToCart={product.canAddToCart}
            isStandardKit={
                product &&
                !!product.configurationType &&
                product.configurationType !== ConfigurationType.None &&
                product.configurationType !== ConfigurationType.Fixed
            }
        />
    );
};

export default connect(mapStateToProps)(withProduct(ProductContextAvailability));
